export function accept_cookies(state){
    return state.accept_cookies
}

export function policy_modal(state){
    return state.policy_modal
}

export function policy_preferences_modal(state){
    return state.policy_preferences_modal
}